/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetDefaultMediaListNameResponseAllOf,
    GetDefaultMediaListNameResponseAllOfFromJSON,
    GetDefaultMediaListNameResponseAllOfFromJSONTyped,
    GetDefaultMediaListNameResponseAllOfToJSON,
} from './GetDefaultMediaListNameResponseAllOf';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';

/**
 * 
 * @export
 * @interface GetDefaultMediaListNameResponse
 */
export interface GetDefaultMediaListNameResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetDefaultMediaListNameResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetDefaultMediaListNameResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof GetDefaultMediaListNameResponse
     */
    mediaListName: string;
}

export function GetDefaultMediaListNameResponseFromJSON(json: any): GetDefaultMediaListNameResponse {
    return GetDefaultMediaListNameResponseFromJSONTyped(json, false);
}

export function GetDefaultMediaListNameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDefaultMediaListNameResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'mediaListName': json['media_list_name'],
    };
}

export function GetDefaultMediaListNameResponseToJSON(value?: GetDefaultMediaListNameResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'media_list_name': value.mediaListName,
    };
}

